import React from "react";
import {Link} from 'react-router-dom';

function Navbar() {
  return (
        <nav class="navbar navbar-expand-lg bg-body-tertiary">
            <div class="container-fluid" style={{justifyContent:"space-between" , margin:"0 0 0 10px"}}>
                <Link to="/"><img src="media/Zerodha.png" alt="logo" style={{height:"20%",width:"15%", marginRight:" 800px"}}></img></Link>
                <Link class="navbar-brand" to="/">Home</Link>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                        <Link class="nav-link active" aria-current="page" to="/signup">Signup</Link>
                        </li>
                        <li class="nav-item">
                        <Link class="nav-link" to="/support">Support</Link>
                        </li>
                        <li class="nav-item">
                        <Link class="nav-link" to="/pricing">pricing</Link>
                        </li>
                        <li class="nav-item">
                        <Link class="nav-link" to="/about">about</Link>
                        </li>
                    </ul>

                </div>
            </div>
        </nav>
  );
}

export default Navbar;
